import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import CardFour from './CardFour';

const createStyles = (theme) =>
  StyleSheet.create({
    grid: {
      width: '100%',
    },
    cardWrapper: {
      width: '100%',
    },
  });

const extractNames = (product = {}) => {
  let en = product.product_name_en || product.product_name || "";
  let ta = product.product_name_ta || "";

  if (!ta && en) {
    if (en.includes(" - ")) {
      const parts = en.split(" - ");
      en = parts[0].trim();
      ta = parts.slice(1).join(" - ").trim();
    } else if (en.includes("/")) {
      const parts = en.split("/");
      en = parts[0].trim();
      ta = parts.slice(1).join("/").trim();
    } else if (en.includes(",")) {
      const parts = en.split(",");
      en = parts[0].trim();
      ta = parts.slice(1).join(",").trim();
    } else {
      const hasTamil = /[\u0B80-\u0BFF]/.test(en);
      if (hasTamil) {
        const taMatches = en.match(/[\u0B80-\u0BFF\s.,0-9]+/g);
        const enMatches = en.match(/[A-Za-z0-9\s.,&'-]+/g);
        if (taMatches && enMatches) {
          const extractedTa = taMatches.join(" ").trim();
          const extractedEn = enMatches.join(" ").trim();
          if (extractedTa && extractedEn) {
            en = extractedEn;
            ta = extractedTa;
          }
        }
      }
    }
  }
  return { en, ta };
};

const ProductGrid = ({ products, categoryDiscount, productCounter, theme, itemsOnThisPage, hasPageHeader }) => {
  const styles = createStyles(theme);
  return (
    <View style={styles.grid}>
      {(products || []).map((product, index) => {
        const netRate = parseFloat(product.net_rate) || 0;
        const discount = parseFloat(categoryDiscount) || 0;
        const discountedRate = product.discountToggle ? (netRate * (100 - discount)) / 100 : netRate;

        const { en, ta } = extractNames(product);

        return (
          <View key={index} style={styles.cardWrapper}>
            <CardFour
              sno={productCounter}
              product={en}
              productTa={ta}
              netrate={netRate.toFixed(2)}
              per={product.per_unit}
              discountrate={product.discountToggle ? discountedRate.toFixed(2) : ''}
              theme={theme}
              discountLocked={product.discountToggle}
              itemsOnThisPage={itemsOnThisPage}
              hasPageHeader={hasPageHeader}
            />
          </View>
        );
      })}
    </View>
  );
};

export default ProductGrid;